import { t } from 'i18next';

export interface RuleSet {
	length: {
		min: number;
		max: number;
	};
	regex: {
		pattern: string;
		patternMessage: string;
		whitelistMode: boolean;
	};
}

export function validate(fieldname: string, ruleSet: RuleSet | undefined, text: string) {
	const returnObject = {
		valid: true,
		message: '',
	};
	if (!ruleSet) {
		return returnObject;
	}

	if (ruleSet.length.min > 0 && text.length < ruleSet.length.min) {
		returnObject.valid = false;
		returnObject.message = t(fieldname) + t('validation.length.min', { min: ruleSet.length.min });
		return returnObject;
	}
	if (ruleSet.length.max > 0 && text.length > ruleSet.length.max) {
		returnObject.valid = false;
		returnObject.message = t(fieldname) + t('validation.length.max', { max: ruleSet.length.max });
		return returnObject;
	}
	const regExp = new RegExp(ruleSet.regex.pattern);
	if (ruleSet.regex.whitelistMode ? !regExp.test(text) : regExp.test(text)) {
		returnObject.valid = false;
		returnObject.message = t(fieldname) + t('validation.pattern') + t(ruleSet.regex.patternMessage);
		return returnObject;
	}
	return returnObject;
}
